import { AnalyticsBrowser } from '@segment/analytics-next';
import axios from 'axios';

import { createGuestApiClient } from '@src/api-clients/guest-api-client';
import { createReservationApiClient } from '@src/api-clients/reservation-api-client';
import {
  AMENDMENT_API_PREFIX,
  CHECKOUT_API_PREFIX,
  CURRENCIES_API_PREFIX,
  OFFERS_API_PREFIX,
  PRODUCT_API_URL,
  WEATHER_API_URL,
} from '@src/constants/apis';
import { SegmentService } from '@src/features/analytics/services';
import { authService } from '@src/features/auth/services';
import { CheckoutService } from '@src/services/api/checkout/checkout.service';
import { CartItemService } from '@src/services/api/checkout/items/cart-item.service';
import { ExtendStayService } from '@src/services/api/checkout/items/extend-stay.service';
import { InvoiceService } from '@src/services/api/invoices/invoice.service';
import { OffersService } from '@src/services/api/offers/offers.service';
import productApiNetworkService, {
  productApiNetworkServiceFactory,
  productApiV2NetworkService,
} from '@src/services/api/product-api-network.service';
import { TripActionsService } from '@src/services/api/trips/trip-actions/trip-actions.service';
import { TripV2Service } from '@src/services/api/trips/trip-v2.service';
import { TripService } from '@src/services/api/trips/trip.service';
import { CrossDomainSessionService } from '@src/services/misc/cross-domain-session.service';
import { TimeService } from '@src/services/misc/time.service';
import { WeatherService } from '@src/services/weather/weather.service';

import { AmendmentService } from './api/amendment/amendment.service';
import { CurrencyService } from './misc/currency.service';

const weatherNetworkService = axios.create({
  baseURL: WEATHER_API_URL,
});

export const timeService = new TimeService();

export const segmentService = new SegmentService(new AnalyticsBrowser());
export const invoiceService = new InvoiceService(productApiNetworkService);
export const tripService = TripService.create(productApiNetworkService);
export const tripV2Service = new TripV2Service(productApiV2NetworkService);
export const tripActionsService = TripActionsService.create(productApiNetworkService);
export const weatherService = new WeatherService(weatherNetworkService);
export const checkoutService = new CheckoutService(productApiNetworkServiceFactory(CHECKOUT_API_PREFIX), authService);
export const currencyService = new CurrencyService(productApiNetworkServiceFactory(CURRENCIES_API_PREFIX));
export const cartItemService = new CartItemService(productApiNetworkServiceFactory(CHECKOUT_API_PREFIX), authService);
export const extendStayService = ExtendStayService.create(
  productApiNetworkServiceFactory(CHECKOUT_API_PREFIX),
  authService,
);
export const offersService = OffersService.create(productApiNetworkServiceFactory(OFFERS_API_PREFIX), authService);
export const amendmentService = AmendmentService.create(
  productApiNetworkServiceFactory(AMENDMENT_API_PREFIX),
  authService,
);

export const reservationApi = createReservationApiClient(PRODUCT_API_URL, {
  axiosInstance: productApiV2NetworkService,
});

export const guestApi = createGuestApiClient(PRODUCT_API_URL, {
  axiosInstance: productApiV2NetworkService,
});

export const crossDomainSessionService = new CrossDomainSessionService();
